/* eslint-disable no-console */
/* eslint-disable no-eval */
import EventAgentJS from '@hotmart/event-agent-js'
import HubMetrifyEvent from '@hotmart/event-agent-js/dist/models/hub-metrify-event'

const system = 'app_business_workspace'

EventAgentJS.mode = process.env.NODE_ENV === 'production' ? 'production' : 'staging'

export class DataHub {
  static sendDHEvent(entity, action, event = {}, eventSystem?: string) {
    return EventAgentJS.send({
      system: eventSystem ?? system,
      entity,
      action,
      event
    })
  }

  static sendDHMetrifyEvent(event: HubMetrifyEvent, element?: Element) {
    return EventAgentJS.sendMetrify(
      {
        system,
        event
      },
      element
    )
  }
}
